import {
  GetIFDefinitionsRequest,
  GetIFDefinitionsResponse,
  GetIFDefinitionHistoryRequest,
  GetIFDefinitionHistoryResponse,
  GetIfDefinitionForReferenceRequest,
  GetIfDefinitionForReferenceResponse,
  UpdateIFDefinitionsRequest,
  UpdateIFDefinitionsResponse,
  UpdateIFDefinitionsGodRequest,
  UpdateIFDefinitionsGodResponse,
  GetIfDefinitionCommonValidationResultRequest,
  GetIfDefinitionCommonValidationResultResponse,
  IfDefinitionReportRequest,
  GetIfDefinitionReviewDiffsRequest,
  GetIfDefinitionReviewDiffsResponse,
  interfaceListRestResource,
} from ".";
import { useRestResourceHook } from "../use-rest-resource-hook";

export const useGetIFDefinitions = () =>
  useRestResourceHook<GetIFDefinitionsRequest, GetIFDefinitionsResponse>(
    (request) => interfaceListRestResource.getIfDefinitions(request),
  );

export const useGetIFDefinitionHistory = () =>
  useRestResourceHook<
    GetIFDefinitionHistoryRequest,
    GetIFDefinitionHistoryResponse
  >((request) => interfaceListRestResource.getIFDefinitionHistory(request));

export const useGetIfDefinitionForReference = () =>
  useRestResourceHook<
    GetIfDefinitionForReferenceRequest,
    GetIfDefinitionForReferenceResponse
  >((request) =>
    interfaceListRestResource.getIfDefinitionForReference(request),
  );

export const useUpdateIfDefinitions = () =>
  useRestResourceHook<UpdateIFDefinitionsRequest, UpdateIFDefinitionsResponse>(
    (request) => interfaceListRestResource.updateIfDefinitions(request),
  );

export const useUpdateIfDefinitionsGod = () =>
  useRestResourceHook<
    UpdateIFDefinitionsGodRequest,
    UpdateIFDefinitionsGodResponse
  >((request) => interfaceListRestResource.updateIfDefinitionsGod(request));

export const useGetIfDefinitionCommonValidationResult = () =>
  useRestResourceHook<
    GetIfDefinitionCommonValidationResultRequest,
    GetIfDefinitionCommonValidationResultResponse
  >((request) =>
    interfaceListRestResource.getIfDefinitionCommonValidationResult(request),
  );

export const useGetIfDefinitionReviewDiffs = () =>
  useRestResourceHook<
    GetIfDefinitionReviewDiffsRequest,
    GetIfDefinitionReviewDiffsResponse
  >((request) => interfaceListRestResource.getIfDefinitionReviewDiffs(request));

export const useIfDefinitionReport = () =>
  useRestResourceHook<IfDefinitionReportRequest, void>(async (request) =>
    interfaceListRestResource.ifDefinitionReport(request),
  );
